import { useCallback, useState } from "react";
import { ANALYTICS_EVENTS, trackEvent } from "utils/analytics";
import type { UseComparePlanArgs, UseComparePlanResult } from "./types";

export const useComparePlan = ({
  planRecords,
}: UseComparePlanArgs): UseComparePlanResult => {
  const [comparisonBaseRecordIndex, setComparisonBaseRecordIndex] = useState<
    number | null
  >(null);

  const comparisonBasePlanRecord =
    comparisonBaseRecordIndex !== null
      ? (planRecords[comparisonBaseRecordIndex] ?? null)
      : null;

  const openPlanComparison = useCallback(
    (recordIndex: number) => {
      if (!planRecords[recordIndex]) return;
      trackEvent(ANALYTICS_EVENTS.SMART_SURVEYOR_PLAN_COMPARISON_OPENED);
      setComparisonBaseRecordIndex(recordIndex);
    },
    [planRecords],
  );

  const closePlanComparison = useCallback(() => {
    setComparisonBaseRecordIndex(null);
  }, []);

  return {
    comparisonBasePlanRecord,
    openPlanComparison,
    closePlanComparison,
  };
};
